import _createForOfIteratorHelper from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _toConsumableArray from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { logger as E } from "../../shared-lib/index.js";
import { getUser as ao } from "../Core/get-user.js";
import { BRAZE_MUST_BE_INITIALIZED_ERROR as w } from "../common/constants.js";
import r from "../managers/braze-instance.js";
import { keys as C } from "../util/code-utils.js";
export var buildBrazeBridge = function buildBrazeBridge(t, e) {
  var o = {
      display: {},
      web: {}
    },
    requestPushPermission = function requestPushPermission() {
      return function () {
        var t = arguments;
        import("../Push/request-push-permission.js").then(function (e) {
          r.ao() ? e.requestPushPermission.apply(e, _toConsumableArray(Array.prototype.slice.call(t))) : E.error(w);
        });
      };
    },
    n = {
      requestImmediateDataFlush: function requestImmediateDataFlush() {
        var t = arguments;
        import("../Core/request-immediate-data-flush.js").then(function (_ref) {
          var requestImmediateDataFlush = _ref.requestImmediateDataFlush;
          r.ao() ? requestImmediateDataFlush.apply(void 0, _toConsumableArray(Array.prototype.slice.call(t))) : E.error(w);
        });
      },
      logCustomEvent: function logCustomEvent() {
        var t = arguments;
        import("../Core/log-custom-event.js").then(function (_ref2) {
          var logCustomEvent = _ref2.logCustomEvent;
          if (!r.ao()) return void E.error(w);
          logCustomEvent.apply(void 0, _toConsumableArray(Array.prototype.slice.call(t)));
        });
      },
      logPurchase: function logPurchase() {
        var t = arguments;
        import("../Core/log-purchase.js").then(function (_ref3) {
          var logPurchase = _ref3.logPurchase;
          if (!r.ao()) return void E.error(w);
          logPurchase.apply(void 0, _toConsumableArray(Array.prototype.slice.call(t)));
        });
      },
      unregisterPush: function unregisterPush() {
        var t = arguments;
        import("../Push/unregister-push.js").then(function (_ref4) {
          var unregisterPush = _ref4.unregisterPush;
          r.ao() ? unregisterPush.apply(void 0, _toConsumableArray(Array.prototype.slice.call(t))) : E.error(w);
        });
      },
      requestPushPermission: requestPushPermission(),
      changeUser: function changeUser() {
        var t = arguments;
        import("../Core/change-user.js").then(function (_ref5) {
          var changeUser = _ref5.changeUser;
          if (!r.ao()) return void E.error(w);
          changeUser.apply(void 0, _toConsumableArray(Array.prototype.slice.call(t)));
        });
      }
    },
    s = function s(t) {
      return function () {
        n[t].apply(n, _toConsumableArray(Array.prototype.slice.call(arguments)));
      };
    };
  var _iterator = _createForOfIteratorHelper(C(n)),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _t2 = _step.value;
      o[_t2] = s(_t2);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var i = ["setFirstName", "setLastName", "setEmail", "setGender", "setDateOfBirth", "setCountry", "setHomeCity", "setEmailNotificationSubscriptionType", "setLanguage", "addAlias", "setPushNotificationSubscriptionType", "setPhoneNumber", "setCustomUserAttribute", "addToCustomAttributeArray", "removeFromCustomAttributeArray", "incrementCustomUserAttribute", "setCustomLocationAttribute", "addToSubscriptionGroup", "removeFromSubscriptionGroup", "setLineId"],
    u = function u(t) {
      return function () {
        var e = ao();
        e && e[t].apply(e, _toConsumableArray(Array.prototype.slice.call(arguments)));
      };
    },
    c = {};
  for (var _t = 0; _t < i.length; _t++) c[i[_t]] = u(i[_t]);
  o.getUser = function () {
    return c;
  };
  var a = {},
    m = function m(r) {
      return function () {
        var o = arguments;
        "function" != typeof e ? a[r].apply(a, _toConsumableArray(Array.prototype.slice.call(o))) : e(t, function () {
          a[r].apply(a, _toConsumableArray(Array.prototype.slice.call(o)));
        });
      };
    },
    f = o.display;
  var _iterator2 = _createForOfIteratorHelper(C(a)),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _t3 = _step2.value;
      f[_t3] = m(_t3);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  var l = {
      registerAppboyPushMessages: requestPushPermission()
    },
    p = function p(t) {
      return function () {
        l[t].apply(l, _toConsumableArray(Array.prototype.slice.call(arguments)));
      };
    },
    y = o.web;
  var _iterator3 = _createForOfIteratorHelper(C(l)),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _t4 = _step3.value;
      y[_t4] = p(_t4);
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return o;
};
export var applyNonceToDynamicallyCreatedTags = function applyNonceToDynamicallyCreatedTags(t, e, r) {
  var o = "([\\w]+)\\s*=\\s*document.createElement\\(['\"]".concat(r, "['\"]\\)"),
    n = t.match(new RegExp(o));
  if (n) {
    var _r = "".concat(n[1], ".setAttribute(\"nonce\", \"").concat(e, "\")");
    return "".concat(t.slice(0, n.index + n[0].length), ";").concat(_r, ";").concat(t.slice(n.index + n[0].length));
  }
  return null;
};
export var attachHtmlToIframeWithNonce = function attachHtmlToIframeWithNonce(t, e, r) {
  var o = null;
  if (null != r) {
    o = document.createElement("html"), o.innerHTML = e || "";
    var _t5 = o.getElementsByTagName("style");
    for (var _e = 0; _e < _t5.length; _e++) _t5[_e].setAttribute("nonce", r);
    var n = o.getElementsByTagName("script");
    for (var _t6 = 0; _t6 < n.length; _t6++) {
      n[_t6].setAttribute("nonce", r), n[_t6].innerHTML = n[_t6].innerHTML.replace(/<style>/g, "<style nonce='".concat(r, "'>"));
      var _e2 = applyNonceToDynamicallyCreatedTags(n[_t6].innerHTML, r, "script");
      _e2 && (n[_t6].innerHTML = _e2);
      var _o = applyNonceToDynamicallyCreatedTags(n[_t6].innerHTML, r, "style");
      _o && (n[_t6].innerHTML = _o);
    }
  }
  t.srcdoc = o ? o.innerHTML : e || "";
};